import React, {useEffect} from "react";
import { useLocation } from "react-router-dom";
import NavPublicUser from "../navbarPublicUser";
import PublHomeData from "../PublHomeData";
import Footer from "../Footer";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from "react-redux";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { IoIosCart } from "react-icons/io";
import './ProductPage.css'; // Updated CSS

export default function ProductPage() {
  const location = useLocation();
  const phoneNo = useSelector(state => state.pubLogin.userPhone);
  const product = location.state?.product;
 
  useEffect(() => {
  window.scrollTo(0, 0);
}, [location.pathname]);
  
  const handleAddToCart = async (product) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/checkCart`,
        { productName: product.name, customerPhone: phoneNo }
      );

      if (response.data.exists) {
        toast.info(`${product.name} is already in the cart. You can increase the quantity.`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        const newData = {
          productName: product.name,
          productWeight: product.weight,
          productPrice: product.price,
          customerPhone: phoneNo,
        };

        toast.success(`${product.name} added to cart!`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        await axios.post(`${process.env.REACT_APP_API_URL}/pubCart`, newData);
      }
    } catch (error) {
      console.error("Error checking cart:", error.message);
      if (error.response) {
        console.error("Server responded with status:", error.response.status);
      }
    }
  };

  const filteredProduct = PublHomeData.find(
    (item) => item.name === product?.name && item.weight === product?.weight
  );

  const noSelectStyle = {
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    OUserSelect: "none"
  };

  return (
    <div>
      <NavPublicUser />
      <div className="container mt-5">
        {filteredProduct && (
          <div className="row justify-content-center align-items-center" style={noSelectStyle}>
            <div className="col-lg-6 d-flex justify-content-center">
              <img
                src={filteredProduct.img}
                className="img-fluid product-image"
                alt={filteredProduct.name}
              />
            </div>
            <div className="col-lg-6 text-center">
              <h2 className="product-title">{filteredProduct.name}</h2>
              <h3 className="product-description">{filteredProduct.descrption}</h3>
              <h4 className="product-price">
                Price: <FaIndianRupeeSign className="rupee-icon" />
                {filteredProduct.price}
              </h4>
              <h5 className="product-weight">Weight: {filteredProduct.weight}</h5>
              <button
                type="button"
                className="btn btn-outline-dark mt-3 btn-lg rounded-pill shadow"
                onClick={() => handleAddToCart(filteredProduct)}
              >
                <IoIosCart /> Add to Cart
              </button>
            </div>
          </div>
        )}
      </div>
      <Footer />
      <ToastContainer />
    </div>
  );
}
